import Icon from '../components/Icon.vue'

Icon.register({
  'grin-alt': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 8C111 8 0 119 0 256S111 504 248 504 496 393 496 256 385 8 248 8zM311.7 136.7C319.3 125.3 336.4 125 344.4 136.7 356.8 155.1 359.5 173.6 360.1 192 359.6 210.4 356.8 228.9 344.4 247.3 336.8 258.7 319.7 259 311.7 247.3 299.3 228.9 296.6 210.4 296 192 296.5 173.6 299.3 155.1 311.7 136.7zM151.7 136.7C159.3 125.3 176.4 125 184.4 136.7 196.8 155.1 199.5 173.6 200.1 192 199.6 210.4 196.8 228.9 184.4 247.3 176.8 258.7 159.7 259 151.7 247.3 139.3 228.9 136.6 210.4 136 192 136.5 173.6 139.3 155.1 151.7 136.7zM248 432C187.4 432 113.5 393.7 104.2 338.7 102.2 326.9 113.5 317.1 124.9 320.8 155.1 330.5 200 336 248 336S340.9 330.5 371.1 320.8C382.5 317.1 393.7 326.9 391.8 338.7 382.5 393.7 308.6 432 248 432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/grin-alt.js
// module id = Hf+E
// module chunks = 144